import { FormBase } from 'core/components';

export default class DimensionsStepForm extends FormBase {
	constructor(hooks) {
		super(hooks);
		this.state.options.set({
			showErrorsOnReset: true,
		});
	}
	setup() {
		return {
			// `pallets` is an array field populated at runtime in LTL packing mode: one entry per physical pallet
			// (or group of identical pallets), each with the products (`contents`) stacked on it. Non-LTL flows leave
			// it empty so its rules never fire.
			fields: [
				'boxId',
				'name',
				'height',
				'width',
				'length',
				'palletUpc',
				'pallets',
				'pallets[].palletLength',
				'pallets[].palletWidth',
				'pallets[].palletHeight',
				'pallets[].palletWeight',
				'pallets[].palletCount',
				'pallets[].isStackable',
				'pallets[].weightOverridden',
				'pallets[].isClosed',
				'pallets[].contents',
				'pallets[].contents[].fulfillmentOrderItemId',
				'pallets[].contents[].sku',
				'pallets[].contents[].productName',
				'pallets[].contents[].quantity',
			],
			labels: {
				boxId: 'FULFILLMENTORDER.LABELINGMODE.DIMENSIONSSTEP.BOXDIMENSIONS',
				name: 'FULFILLMENTORDER.LABELINGMODE.DIMENSIONSSTEP.NAME',
				height: 'FULFILLMENTORDER.LABELINGMODE.DIMENSIONSSTEP.HEIGHT',
				width: 'FULFILLMENTORDER.LABELINGMODE.DIMENSIONSSTEP.WIDTH',
				length: 'FULFILLMENTORDER.LABELINGMODE.DIMENSIONSSTEP.LENGTH',
				palletUpc: 'FULFILLMENTORDER.LABELINGMODE.DIMENSIONSSTEP.SCANITEM',
				'pallets[].palletLength': 'FULFILLMENTORDER.LABELINGMODE.DIMENSIONSSTEP.PALLETLENGTH',
				'pallets[].palletWidth': 'FULFILLMENTORDER.LABELINGMODE.DIMENSIONSSTEP.PALLETWIDTH',
				'pallets[].palletHeight': 'FULFILLMENTORDER.LABELINGMODE.DIMENSIONSSTEP.PALLETHEIGHT',
				'pallets[].palletWeight': 'FULFILLMENTORDER.LABELINGMODE.DIMENSIONSSTEP.PALLETWEIGHT',
				'pallets[].palletCount': 'FULFILLMENTORDER.LABELINGMODE.DIMENSIONSSTEP.PALLETCOUNT',
				'pallets[].contents[].fulfillmentOrderItemId': 'FULFILLMENTORDER.LABELINGMODE.DIMENSIONSSTEP.PRODUCT',
				'pallets[].contents[].quantity': 'FULFILLMENTORDER.LABELINGMODE.DIMENSIONSSTEP.QUANTITY',
			},
			rules: {
				boxId: 'required',
				name: 'required',
				height: 'required|numeric',
				width: 'required|numeric',
				length: 'required|numeric',
				'pallets[].palletLength': 'required|numeric|numericMinValue|notZero',
				'pallets[].palletWidth': 'required|numeric|numericMinValue|notZero',
				'pallets[].palletHeight': 'required|numeric|numericMinValue|notZero',
				'pallets[].palletWeight': 'required|numeric|numericMinValue|notZero',
				'pallets[].palletCount': 'required|numeric|numericMinValue|notZero|integer',
				'pallets[].contents[].fulfillmentOrderItemId': 'required',
				// Quantity may be 0 (item not on this pallet); the "N left" reconciliation enforces the real constraint.
				'pallets[].contents[].quantity': 'numeric|integer',
			},
		};
	}
}
